import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { MappingClientT, ObjectContainerClientT, ObjectTypeClientT, StatusClientT } from 'bovaljaren-models';
import './ObjectListDropDown.scss';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import ObjectList from '../ObjectList';
import { AppContext } from '../../../../state/app.state';
import { SidebarFilterBlock, SidebarFilterCheckbox } from '../../../Wrappers';
import { isMobile } from '../../../../utils/app.helper';
import { useObserver } from 'mobx-react-lite';
import BrandingService from '../../../../services/branding.service';
import { ObosChevronDown, ObosChevronUp } from '../../../../icons/obos/obosIcons';

type Props = {
    objects?: ObjectContainerClientT[];
    open?: boolean;
    setOpen: (value: boolean) => void;
    types?: ObjectTypeClientT[];
    statuses?: StatusClientT[];
    objectMappings?: MappingClientT[];
    selectedObjectId?: number | null;
    setSelectedObjectId: (value: number) => void;
    onObjectListRowEnter?: (objectId: number) => void;
    fullSize?: boolean;
    onObjectListRowLeave?: (objectId: number) => void;
}

const ObjectListDropDown: React.FC<Props> = ({ children, objects, types, setSelectedObjectId, open = false, setOpen, onObjectListRowEnter, onObjectListRowLeave, statuses, objectMappings, fullSize = false }): ReactElement => {
    const { filterState, state } = useContext(AppContext);

    const onDataClick = (o: ObjectContainerClientT): void => {
        setSelectedObjectId(o.id);
    };

    const getExpandArrow = () => {

        if (BrandingService.check(['obos'])) {
            return open ? <ObosChevronUp onClick={toggleOpen} /> : <ObosChevronDown onClick={toggleOpen}/>;
        }

        return open ? <ExpandLess onClick={toggleOpen} /> : <ExpandMore onClick={toggleOpen}/>;
    };

    const renderTitle = (): string => {
        return !open ? 'Visa objektlista' : 'Dölj objektlista';
    };

    let mainObjectTypeId: number;

    if (objects && objects.length) {
        mainObjectTypeId = objects[0]?.objectTypeId;
    }

    const mainObjectType = types?.find(type => type.id === mainObjectTypeId);

    const toggleOpen = (): void => {
        setOpen(!open);
    };

    return useObserver(() => (
        <div id='bv-object-list-wrapper' className='bv-object-list-wrapper' style={{ height: open ? '100%' : 'auto' }}>
            <div className={'bv-object-list-dropdown-btn'} onClick={toggleOpen}>
                <div className={'bv-object-list-expand-icon'} onClick={toggleOpen}></div>
                <div className={'bv-object-list-title'} onClick={toggleOpen}>
                    {renderTitle()}
                </div>
                <div className={'bv-object-list-expand-icon'} onClick={toggleOpen}>{
                    getExpandArrow()
                }
                </div>
            </div>
            {filterState?.filters && filterState.filters.length > 0 && <SidebarFilterBlock className={open ? 'bv-sidebar-filter-block--expanded' : ''}>
                {
                    filterState?.filters?.map ((v, i) => {
                        return <SidebarFilterCheckbox
                            key={i}
                            defaultChecked={!!filterState.appliedFilters.find(f => f === v)}
                            onChange={(value): void => filterState?.applyRoomFilter(v, value, state?.objects)}
                            label={`${v}or`}></SidebarFilterCheckbox>;
                    })
                }
            </SidebarFilterBlock>}
            {open && <div
                className={'bv-object-list-container'}
                style={{ maxHeight: isMobile() ? '20rem' : fullSize ? 'calc(100% - 98px)' : 'calc(80% - 98px)' }}
            >
                {children}
                {mainObjectType && <ObjectList
                    objectMappings={objectMappings}
                    objects={objects}
                    objectType={mainObjectType}
                    statuses={statuses}
                    onObjectListRowLeave={onObjectListRowLeave}
                    onObjectListRowEnter={onObjectListRowEnter}
                    onDataClick={onDataClick}
                />}
            </div>}
        </div>
    ));
};


export default ObjectListDropDown;